
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/twitch-drops/[uid]",
      function () {
        return require("private-next-pages/twitch-drops/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/twitch-drops/[uid]"])
      });
    }
  